import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Sistema PRO Psiquiatría transformó por completo mi forma de documentar. Las plantillas de historia clínica y el protocolo de entrevista inicial me dieron la estructura que siempre busqué y nunca encontré en un solo lugar. Lo recomiendo a cualquier psiquiatra que quiera trabajar con más orden, seguridad y profesionalismo.',
  author: 'G — Gabriel T.',
  role: 'Psiquiatra en Consultorio Privado'
}, {
  quote: 'El Tomo III, el del escudo legal, me cambió la cabeza. Nunca había dimensionado el riesgo que corría sin consentimientos claros y registros de decisiones de riesgo. Ahora trabajo con una tranquilidad que antes no tenía.',
  author: 'M — Marcela R.',
  role: 'Psiquiatra en Hospital Público y Práctica Privada'
}, {
  quote: 'El planificador de farmacoterapia es exactamente lo que necesitaba. Tengo pacientes con polifarmacia compleja y ahora puedo controlar todo desde un solo documento. Claro, organizado y profesional.',
  author: 'D — Diego F.',
  role: 'Psiquiatra especializado en Trastornos del Ánimo'
}, {
  quote: 'La guía de urgencias y crisis me dio seguridad ante situaciones que antes me generaban mucha tensión. El protocolo de riesgo suicida especialmente es una herramienta que todo psiquiatra debería tener a mano.',
  author: 'L — Laura P.',
  role: 'Psiquiatra en Centro de Salud Mental'
},
// New testimonials
{
  quote: 'Desde que uso el Sistema PRO, mis informes para obras sociales me llevan la mitad del tiempo. Es una herramienta imprescindible.',
  author: 'Natalia G., 38 años',
  role: 'Psiquiatra en Consultorio Privado, Córdoba'
}, {
  quote: 'El protocolo de riesgo suicida me salvó en una guardia. Tener todo estructurado te da una seguridad que no tiene precio.',
  author: 'Hernán D., 45 años',
  role: 'Psiquiatra en Hospital Público, Tucumán'
}, {
  quote: 'Mis colegas no podían creer lo organizada que estaba mi documentación. Todo gracias al Sistema PRO.',
  author: 'Soledad M., 33 años',
  role: 'Residente de Psiquiatría, Rosario'
}, {
  quote: 'La guía de psicoeducación para familias redujo mis consultas repetitivas un 40%. Brillante recurso.',
  author: 'Esteban L., 52 años',
  role: 'Psiquiatra en Clínica Privada, Mendoza'
}, {
  quote: 'Invertí en el Plan Elite y se pagó solo en la primera semana. La calidad de las plantillas es excepcional.',
  author: 'Mariana C., 41 años',
  role: 'Psiquiatra Forense, Buenos Aires'
}];
export function TestimonialsSection() {
  const displayedTestimonials = testimonials.slice(0, 5);
  return <section className="py-10 md:py-14 bg-navy-light border-t border-navy-lighter overflow-hidden" data-id="element-186">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-187">
        <div className="text-center mb-6 md:mb-8" data-id="element-188">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-2xl md:text-4xl font-serif font-bold text-white mb-2" data-id="element-189">
            Lo que dicen los profesionales
          </motion.h2>
          <div className="flex justify-center gap-1" data-id="element-190">
            {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-191" />)}
          </div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4
      }} className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-3" data-id="element-192">
          {displayedTestimonials.map((testimonial, index) => <div key={index} className="glass-panel rounded-lg p-3.5 border border-navy-lighter hover:border-gold/30 transition-colors relative flex flex-col bg-navy/40" data-id="element-193">
              <Quote className="absolute top-2.5 right-2.5 w-5 h-5 text-gold/10" data-id="element-194" />
              <div className="flex gap-0.5 mb-2" data-id="element-195">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-2.5 h-2.5 fill-gold text-gold" data-id="element-196" />)}
              </div>
              <p className="text-gray-300 mb-3 italic leading-snug text-xs" data-id="element-197">
                "{testimonial.quote}"
              </p>
              <div className="border-t border-white/10 pt-2 mt-auto" data-id="element-198">
                <p className="font-bold text-white text-xs" data-id="element-199">
                  {testimonial.author}
                </p>
                <p className="text-gold text-[10px] mt-0.5 line-clamp-1" title={testimonial.role} data-id="element-200">
                  {testimonial.role}
                </p>
              </div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}